import { isObject } from '@yandex-int/messenger.utils';

import { SUPPORTED_PARENT_FRAMES, TYPE_INIT_MESSAGE_WITH_PORT } from './constants';
import { SupportedParentFrame } from './types';

interface InitConnectionMessage {
    type: typeof TYPE_INIT_MESSAGE_WITH_PORT;
    name: SupportedParentFrame;
    authToken?: string;
}

export const isInitConnectionMessage = (
    event: MessageEvent
): event is MessageEvent<InitConnectionMessage> & {
    ports: [MessagePort, ...MessagePort[]];
} => {
    if (!event || !isObject(event)) {
        return false;
    }

    return (
        event.ports.length > 0 &&
        'type' in event.data &&
        typeof event.data.type === 'string' &&
        event.data.type === TYPE_INIT_MESSAGE_WITH_PORT &&
        'name' in event.data &&
        typeof event.data.name === 'string' &&
        SUPPORTED_PARENT_FRAMES.includes(event.data.name as SupportedParentFrame)
    );
};
